import { useEffect } from "react";
import { useForm } from "react-final-form";
import { FIELD_NAMES, defaultNativeRDPValues, DEFAULT_V4_MAX_CONNECTION, integerBetween } from "@p81-common/shell-core-js";

export function useMaxConnectionsForV4Apps(protocol, isSelectedNetworkV4, currentMaxConnections, isNative) {
  const form = useForm();
  
  useEffect(() => {
    if (isSelectedNetworkV4) {
      const v4MaxConnections = isNative 
        ? defaultNativeRDPValues.maxConnections 
        : DEFAULT_V4_MAX_CONNECTION;
      form.change(
        `${protocol}.${FIELD_NAMES.ATTRIBUTES_MAX_CONNECTIONS}`,
        v4MaxConnections
      );
    }
  }, [isSelectedNetworkV4, protocol, form, isNative]);

  const parseMaxConnections = (value) => {
    if (isSelectedNetworkV4) {
      return isNative 
        ? defaultNativeRDPValues.maxConnections 
        : DEFAULT_V4_MAX_CONNECTION;
    }
    return integerBetween(-1, 1024, currentMaxConnections)(value);
  };

  return { parseMaxConnections };
}
